export default __webpack_public_path__ + "static/media/inspiringlight.a5de25e5.png";